export default __webpack_public_path__ + "static/BannerGenericImageTextTitle-ed161ab8751331e7088708ee64a1a8a2.jpg";